import React, { useEffect } from "react";
import { Props } from "~/components/public-env.tsx";

export default function GTM(props: Props) {
  const env = props.APP_ENV;

  const gtmID: string = "GTM-5XZ8HFK";

  /* add via useEffect to fix hydration error */
  useEffect(() => {
    const gtmScript = document.createElement("script");

    gtmScript.innerHTML = `
        (function(w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
              'gtm.start': new Date().getTime(),
              event: 'gtm.js'
          });
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src =
              'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${gtmID}');`;

    document.head.appendChild(gtmScript);
  }, []);
  return <></>; // component needs to return a react node
}
